import React, { useEffect, useRef, useState } from "react";
import viewBg from "assets/images/common/others/viewBg.png";
import { ReactComponent as DeleteIconSvg } from "assets/images/common/svgs/delete.svg";
import { ReactComponent as ArrowBackIcon } from "assets/images/common/svgs/arrow_back.svg";
import { ReactComponent as TrophyBlack } from "assets/images/common/svgs/trophy-black.svg";
import { useNavigate } from "react-router-dom";

import { siteRoutes } from "utils/helpers/enums/routes.enum";
import PersonalInformation from "./component/PersonalInformation";
import Wallet from "./component/Wallet";
import Badges from "./component/Badges";
import useUsers from "containers/user-management/useHooks";
import useUtils from "hooks/useUtils";
import { useSelector } from "react-redux";
import { concatPathWithBackendUrl } from "utils/helpers/urlHelper";
import editProfilePicUser from "assets/images/common/others/editProfileUSer.png";
import Activities from "./component/Activities";
import Events from "./component/Event";

interface Tab {
  name: string;
  Component: JSX.Element;
}

const ViewAmbassador = () => {
  const navigate = useNavigate();
  const [user, setUser] = useState<any>({});
  const [data, setData] = useState<any[]>([]);
  const ambassador = user?.user;
  const ambassadorName =
    ambassador?.firstName || ambassador?.lastName
      ? `${ambassador?.firstName || ""} ${ambassador?.lastName || ""}`.trim()
      : "Ambassador";
  const tabs: Tab[] = [
    {
      name: "Personal Information",
      Component: <PersonalInformation user={user} />,
    },
    {
      name: "Activities",
      Component: <Activities ambassadorId={user?.user?.id} />,
    },

    { name: "Wallet", Component: <Wallet user={user} /> },
    { name: "Events", Component: <Events ambassadorId={user?.user?.id} /> },
    { name: "Badges", Component: <Badges ambassadorId={user?.user?.id} /> },
    // { name: "Live Session", Component: <LiveSession /> },
  ];
  const [activeTab, setActiveTab] = useState<Tab>(tabs[0]);
  const { getUserById, getActivities } = useUsers();
  const { getQueryParams } = useUtils();
  const { isLoading } = useSelector((state: any) => state.sharedReducer);
  const params = getQueryParams();

  useEffect(() => {
    getUserById(params?.id, setUser);
  }, []);

  useEffect(() => {
    getActivities(setData, { ambassadorId: params?.id });
  }, []);
  console.log(data);
  const goToBack = () => {
    navigate(-1);
  };
  return (
    <div className="pb-5">
      <div className="flex justify-between items-center gap-4 ">
        <h1 className="text-base text-primaryText font-bold mb-6 flex items-center gap-3">
          <span
            onClick={goToBack}
            className="bg-transparentBlueBg w-[44px] h-[44px] rounded-full flex items-center justify-center cursor-pointer"
          >
            <ArrowBackIcon />
          </span>
          {ambassadorName}’s Profile
        </h1>
        {/* <div className="flex items-center gap-6">
          <span className="flex items-center gap-2">
            <p className="text-sm font-bold text-primaryText">Block User</p>
            <label className="switch-field-small">
              <input type="checkbox" />
              <span className="slider"></span>
            </label>
          </span>
          <span className="flex items-center gap-2">
            <p className="text-sm font-bold text-redtext">Delete User</p>
            <DeleteIconSvg />
          </span>
        </div> */}
      </div>
      <div className="flex flex-wrap lg:flex-nowrap gap-4">
        <div className="bg-white border-[0.3px] border-mediumGrayBorder rounded-lg p-6 w-full">
          <div className="flex flex-wrap items-center gap-2 pb-4">
            <span>
              <img
                className="w-[82px] h-[82px] rounded-full object-cover"
                src={
                  ambassador?.profilePicUrl
                    ? concatPathWithBackendUrl(
                        ambassador?.profilePicUrl?.fileDownloadUri
                      )
                    : editProfilePicUser
                }
                alt={ambassadorName}
              />
            </span>
            <span>
              <h2 className="text-base whitespace-pre-wrap font-bold text-primaryText">
                {ambassadorName}
              </h2>
              <p className="text-xs font-medium text-primaryText">
                {/* {user?.user?.currentRole} */}AMBASSADOR
              </p>
            </span>
          </div>
          <div className=" flex flex-wrap gap-4">
            {tabs.map((tab) => (
              <button
                key={tab.name}
                className={`rounded-md px-3 py-2 font-medium text-xs transition-colors duration-300 ${
                  activeTab.name === tab.name
                    ? "bg-vibrantBlueBg text-white "
                    : "bg-warmOffWhiteBg text-mediumGrayText"
                }`}
                onClick={() => setActiveTab(tab)}
              >
                {tab.name}
              </button>
            ))}
          </div>

          <div className="mt-4">
            {" "}
            {activeTab.name === "Personal Information" ? (
              <PersonalInformation user={user} />
            ) : activeTab.name === "Activities" ? (
              <Activities ambassadorId={user?.user?.id} />
            ) : activeTab.name === "Wallet" ? (
              <Wallet user={user} />
            ) : activeTab.name === "Events" ? (
              <Events ambassadorId={user?.user?.id} />
            ) : activeTab.name === "Badges" ? (
              <Badges ambassadorId={user?.user?.id} />
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewAmbassador;
